<bl-modal-content #content
  [title]="'顧客・車両情報の紐付け'"
  [footerButtonType]="modalButtonType.Custom"
>
  <div body>
    <div class="content-message">「①現在承認待ちのお客様情報」と紐付け可能な候補が見つかりました。「②登録されている情報」から選択してください。</div>
    <div class="content-title">①現在承認待ちのお客様情報</div>
    <div class="profile-grid">
      <bl-reference-grid
        [gridOptions]="_profileGridOptions"
        [gridHeight]="'_gridHeight'"
        [headerHeight]="_gridHeaderHeight"
        [rowHeight]="_gridRowHeight"
        [isOperable]="false"
        [pagination]="false"
        (onReady)="onReadyGrid()"
      >
      </bl-reference-grid>
    </div>
    <div class="profile-matching-candidate-title">②登録されている情報</div>
    <div class="profile-matching-grid">
      <bl-reference-grid #refGrid
        [gridOptions]="_gridOptions"
        [gridHeight]="'_gridHeight'"
        [headerHeight]="_gridHeaderHeight"
        [rowHeight]="_gridRowHeight"
        [isOperable]="false"
        [totalCount]="_totalCount"
        [pageSizePatterns]="_gridSizePatterns"
        (onReady)="onReadyGrid()"
        (changePageSize)="onChangePageSize($event)"
        (selectedRowEvent)="onSelectedRow($event)"
      >
      </bl-reference-grid>
    </div>
  </div>
  <div footer>
    <button class="btn btn-default" type="button"
      (click)="content.cancel()">キャンセル
    </button>
    <button class="btn btn-danger" type="button"
      (click)="onDiscard()">破棄
    </button>
    <button class="btn btn-default" type="button"
      [disabled]="data?.profileEntry?.customerCode !== 0"
      (click)="onCreate()">新規登録
    </button>
    <button class="btn btn-success" type="button"
      (click)="content.done()">決定
    </button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/profile-matching-modal/profile-matching-modal.component.html